"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_BID_STATUS_SORT_RANK = exports.getProductBidDisplayStatus = void 0;
const product_bid_1 = require("../enums/product-bid");
const getProductBidDisplayStatus = ({ status, isHighestBid, }) => {
    if (status === product_bid_1.ProductBidStatus.Cancelled) {
        return "cancelled";
    }
    if (status === product_bid_1.ProductBidStatus.Won) {
        return "won";
    }
    if (status === product_bid_1.ProductBidStatus.Lost) {
        return "outbid";
    }
    return isHighestBid ? "topBidder" : "outbid";
};
exports.getProductBidDisplayStatus = getProductBidDisplayStatus;
exports.PRODUCT_BID_STATUS_SORT_RANK = {
    won: 0,
    topBidder: 0,
    outbid: 1,
    cancelled: 2,
};
